export enum CreatedIssuesEnum {
  ALL = 'created-issues.all',
  DRAFT = 'created-issues.draft',
  IN_REVIEW = 'created-issues.open', // Backend field name remains 'open'
  IN_PROGRESS = 'created-issues.in-progress',
  REMEDIATION_PLANNING = 'created-issues.remediation-planning',
  IN_REMEDIATION = 'created-issues.in-remediation',
  TO_BE_PUBLISHED = 'created-issues.to-be-published',
  PENDING_ACCEPTANCE = 'created-issues.pending-acceptance',
}

export enum ManagedIssuesEnum {
  ALL = 'managed-issues.all',
  IN_REVIEW = 'managed-issues.in-review',
  OVERDUE = 'managed-issues.overdue',
  SLA_OVERDUE = 'managed-issues.sla-overdue',
}

export enum OwnedIssuesEnum {
  ALL = 'owned-issues.all',
  OVERDUE = 'owned-issues.overdue',
  TO_BE_APPROVED = 'owned-issues.to-be-approved',
}

export enum OwnedActionsEnum {
  ALL = 'owned-actions.all',
  OPEN = 'owned-actions.open',
  IN_PROGRESS = 'owned-actions.in-progress',
  OVERDUE = 'owned-actions.overdue',
  TO_BE_APPROVED = 'owned-actions.to-be-approved',
  COMPLETED = 'owned-actions.completed',
}

export enum ToBeApprovedEnum {
  ISSUES_TO_APPROVE = 'to-be-approved.issues-to-approve',
  ACTIONS_TO_APPROVE = 'to-be-approved.actions-to-approve',
}

export type QuickFilterAllEnum =
  | CreatedIssuesEnum
  | ManagedIssuesEnum
  | OwnedIssuesEnum
  | OwnedActionsEnum
  | ToBeApprovedEnum;
